import Vue from "vue";
import Vuex from "vuex";

/* eslint-disable no-unused-vars */
import firebase from "firebase";
import { functions } from "@/firebase";

//import { functions } from '@/firebase'

//const urlMaps = "https://mybusiness.googleapis.com/v4/accounts/{accountId}/locations/{locationId}?parameters";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    snackbar: false,
    colorSnack: "success",
    textSnackbar: "",
    datos: {
      singular: "",
      plural: "",
      imagen: "",
    },
  },
  mutations: {
    setDatos(state, d) {
      state.datos = d;
    },
    setSnackSuccess(state, msj) {
      state.colorSnack = "success";
      state.snackbar = true;
      state.textSnackbar = msj;
    },
    setSnackError(state, msj) {
      state.colorSnack = "red";
      state.snackbar = true;
      state.textSnackbar = msj;
    },
    resetSnackBar(state) {
      state.colorSnack = "success";
      state.snackbar = false;
      state.textSnackbar = "";
    },
  },
  /* eslint-disable no-unused-vars */
  actions: {
    sendEmail(_, datos) {
      //db.collection('contactos').add(datos);
      console.log(datos);
      var sendMailF = functions.httpsCallable("sendEmail");
      return sendMailF(datos).then(function(result) {
        // Read result of the Cloud Function.
        console.log(result);
      });
    },
  },
  /* eslint-enable no-unused-vars */
  modules: {},
});
